import React, {useEffect, useState} from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import Dialog from "@material-ui/core/Dialog";
import {DialogTitle} from "../../../components";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import useFromValidator from '../../../common/formValidator';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';

const schema = {
    formulaName: {
        presence: {allowEmpty: false, message: 'is required'}
    }
};

const useStyles = makeStyles(theme => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(0),
        color: theme.palette.text.default,
      },  
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    textField: {
        marginTop: theme.spacing(2)
    },
    signInButton: {
        margin: theme.spacing(2, 0)
    },
    progressContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%'
    },
    progressBar: {
        margin: theme.spacing(2),
        position: 'absolute',
        top: '40%',
        zIndex: '2'
    },
}));

const FeedformulationStorage = ({ deleteErrorMessage, FeedstorageData,errorMessage,setErrorMessage,farmID, onEdit, data, onSave, 
    handleClose, showDialog, editMode}) => {
    const classes = useStyles();
    const [formState, hasError, handleChange, updateData] = useFromValidator(schema);
    const [popupLoading, setPopupLoading] = useState(false) ;
    const resetBeforeEdit = () => {
        if(showDialog){
            updateData(data, editMode);
            setPopupLoading(false);
        }
    };

    useEffect(resetBeforeEdit, [showDialog]);

    const onSubmit = () => {
        const tempData = {
            ...formState.values
        };

        let FeedStorageTemp = [...FeedstorageData];
        
        if (editMode) {
          let editDataIndex = FeedStorageTemp.findIndex(feedStorage => feedStorage.id === tempData.id);
          if (editDataIndex !== -1) {
            FeedStorageTemp.splice(editDataIndex, 1);
          }
        }
        
        
        setPopupLoading(true)
        if (editMode){
                onEdit(tempData, setPopupLoading);
        }
        else
            onSave(tempData, setPopupLoading);
        
    };


    return <Dialog disableBackdropClick open={showDialog} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog- title"   >{editMode ? "Update" : "New"} Feed Storage
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        </DialogTitle>
          <DialogContent>

            <div>
            {
               popupLoading ? 
                <div className={classes.progressContainer}>
                      <CircularProgress  className={classes.progressBar}/ >
                </div> : ""
             }
          <div id="error">
          {errorMessage ? <Chip onDelete={deleteErrorMessage} color="primary" label={errorMessage}/> : ''}
        </div> 

            <TextField
                className={classes.textField}
                error={hasError('formulaName')}
                fullWidth
                helperText={
                    hasError('formulaName') ? formState.errors.formulaName[0] : null
                }
                label="Formula Name"
                name="formulaName"
                onChange={handleChange}
                type="text"
                value={formState.values.formulaName !== undefined ? formState.values.formulaName : ''}
                variant="outlined"
                style={{backgroundColor:"#ffffff"}}
                InputProps={{
                    inputProps: { min: 0.1 }
                }}
            />
                
            </div>

          
        </DialogContent>
        <DialogActions>
            <Button
                className={classes.signInButton}
                color="primary"
                disabled={!formState.isValid}
                size="large"
                type="submit"
                variant="contained"
                onClick={onSubmit}
            >
                Save
            </Button>
        </DialogActions>
    </Dialog>
};

export default FeedformulationStorage;